"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dots = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
class Dots {
    constructor(options) {
        this.options = {
            elementSelector: '',
            colours: [
                'rgba(90, 210, 160, .15)',
                'rgba(180, 75, 125, .15)',
                'rgba(250, 200, 30, .15)'
            ],
            size: 75,
            decay: 6,
            length: 10,
            frames: 5,
            margin: 4,
            newEveryMax: 200,
            newEveryMin: 50 // minimum interval before new circles are started
        };
        this.drawNewDelay = 0;
        this.options = Object.assign(this.options, options);
        window.addEventListener('load', () => {
            this.init();
        });
        window.addEventListener('resize', (0, throttle_1.default)(() => {
            this.init();
        }, 1000));
    }
    init() {
        this.element = document.querySelector(this.options.elementSelector);
        if (this.element) {
            this.clear();
            this.across = Math.floor(this.element.offsetWidth / this.options.size);
            this.down = Math.floor(this.element.offsetHeight / this.options.size);
            this.canvas = document.createElement('canvas');
            this.canvas.width = this.across * this.options.size;
            this.canvas.height = this.down * this.options.size;
            this.element.appendChild(this.canvas);
            this.startAnimation();
        }
    }
    clear() {
        this.circles = [];
        if (this.interval) {
            clearTimeout(this.interval);
        }
        if (this.canvas) {
            this.canvas.remove();
        }
    }
    get ctx() {
        return this.canvas ? this.canvas.getContext('2d') : null;
    }
    startAnimation() {
        this.interval = setInterval(() => this.drawFrame(), 1000 / this.options.frames);
    }
    drawFrame() {
        // has time elapsed to draw an additional circle
        if (this.drawNewDelay < 0) {
            // create a new circle
            this.newCircle();
            // restart drawNewDelay
            this.drawNewDelay = this.random(this.options.newEveryMin, this.options.newEveryMax);
        }
        else {
            // subtract the elapsed time since last redraw
            this.drawNewDelay = this.drawNewDelay - (1000 / this.options.frames);
        }
        // loop over array in reverse and delete expired circles
        for (let i = this.circles.length; i > 0; i--) {
            if (this.circles[i]) {
                this.circles[i].deleteIn--; // decrement delete in by one
                this.circles[i].createIn--; // decrement create in
                if (this.circles[i].deleteIn < 0) {
                    // remove if expired
                    this.circles.splice(i, 1);
                }
            }
        }
        //clear canvas
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        // now draw the circles
        this.circles.forEach(circle => {
            if (circle.createIn <= 0) {
                this.drawCircle(circle);
            }
        });
        // loop matrix and draw circles
    }
    newCircle() {
        let length = this.random(3, this.options.length);
        let direction = this.random(0, 3);
        let startX = this.random(0, this.across);
        let startY = this.random(0, this.down);
        let colour = this.random(0, this.options.colours.length);
        for (let i = 0; i < length; i++) {
            let x;
            let y;
            switch (direction) {
                case 0: // up
                    x = startX;
                    y = startY - i;
                    break;
                case 1: // down
                    x = startX;
                    y = startY + i;
                    break;
                case 2: // left
                    x = startX - i;
                    y = startY;
                    break;
                case 3: // right
                    x = startX + i;
                    y = startY;
                    break;
            }
            this.circles.push({
                x: x,
                y: y,
                colourIndex: colour,
                deleteIn: i + this.options.decay,
                createIn: i
            });
        }
        //console.log(this.startPoints)
    }
    random(min, max) {
        return Math.round(Math.random() * (max - min) + min);
    }
    drawCircle(circle) {
        this.ctx.beginPath();
        //this.ctx.save()
        //console.log('draw circle')
        this.ctx.fillStyle = this.options.colours[circle.colourIndex];
        this.ctx.arc(this.options.size * (circle.x + 0.5), this.options.size * (circle.y + 0.5), (this.options.size - this.options.margin) / 2, 0, Math.PI * 2, true);
        this.ctx.fill();
        //this.ctx.restore()
    }
}
exports.Dots = Dots;
